export const isProductionLogger = () => {
  const env = process.env.NODE_ENV ?? 'production'
  return !['development', 'test'].includes(env)
}
